module.exports = __webpack_public_path__ + "static/media/activate-physical-card-48x48.15789c99.svg";